import React from 'react';
import PropTypes from 'prop-types';
// Models
import { installationName } from 'models/device';
// Custom
import { scenarioDataShape, deviceDataShape } from 'constants/PropTypesShapes';
import withDeviceData from 'appAssets/hocs/WithDeviceData';
import InformationItem from 'components/items/InformationItem';

const ScenarioInformationItem = ({ scenario, deviceData, toggle }) => {
  if (deviceData) {
    return (
      <InformationItem
        icon="itemScenario"
        label={installationName(deviceData)}
        value={scenario.name}
        toggle={toggle}
      />
    );
  }
  return null;
};

ScenarioInformationItem.propTypes = {
  scenario: scenarioDataShape.isRequired,
  deviceData: deviceDataShape,
  toggle: PropTypes.shape({
    toggled: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
  }),
};

ScenarioInformationItem.defaultProps = {
  deviceData: null,
  toggle: null,
};

module.exports = withDeviceData('scenario.device_id')(ScenarioInformationItem);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ScenarioInformationItem.js